import { toast } from 'sonner'
import { create } from 'zustand'

interface CopyFallbackState {
  text: string | null
  label: string | null
  show: (text: string, label?: string) => void
  close: () => void
}

/** Estado del diálogo que muestra el texto cuando el navegador no deja copiarlo (lo dibuja `CopyFallbackHost`). */
export const useCopyFallback = create<CopyFallbackState>((set) => ({
  text: null,
  label: null,
  show: (text, label) => set({ text, label: label ?? null }),
  close: () => set({ text: null, label: null }),
}))

/**
 * Copia texto al portapapeles. `navigator.clipboard` falla sin HTTPS, sin permiso o dentro de iframes: en ese caso
 * avisa en español y muestra el texto seleccionado en un cuadro para copiarlo a mano. Devuelve si se copió.
 */
export async function copyText(
  text: string,
  options: { label?: string; successMessage?: string | false } = {},
): Promise<boolean> {
  try {
    if (!navigator.clipboard) throw new Error('Portapapeles no disponible')
    await navigator.clipboard.writeText(text)
  } catch {
    toast.error('No se pudo copiar al portapapeles. Copialo a mano desde el cuadro que se abrió.')
    useCopyFallback.getState().show(text, options.label)
    return false
  }
  if (options.successMessage !== false) toast.success(options.successMessage ?? 'Copiado')
  return true
}
